import { FC, useState } from 'react';
import { ButtonLink } from '@lambdacurry/component-library';
import { MedusaCart, MedusaDiscount } from 'lib/home/generated/types/api';
import { CartPromoCodeForm } from './CartPromoCodeForm';
import { useRegistrationStore } from '../../../store';

export interface CartPromoCodeProps {
  cart: MedusaCart;
  onPromoCodeApplied?: (discounts: MedusaDiscount[]) => void;
}

export const CartPromoCode: FC<CartPromoCodeProps> = ({ cart, onPromoCodeApplied }) => {
  const [isFormVisible, setIsFormVisible] = useState(false);
  const { promoCode } = useRegistrationStore();
  const discounts = cart?.discounts;

  const promoCodeInvalid =
    !discounts && promoCode ? true : promoCode && !discounts.find(discounts => discounts.code === promoCode);

  return (
    <>
      {promoCodeInvalid && (
        <p className="text-danger text-xs mb-0">
          Promo code <b>{promoCode}</b> is invalid or expired.
        </p>
      )}

      {!isFormVisible && (
        <ButtonLink className="!underline" onClick={() => setIsFormVisible(true)} data-cy="add-discount-code">
          Add promo code
        </ButtonLink>
      )}

      {isFormVisible && <CartPromoCodeForm onPromoCodeApplied={onPromoCodeApplied} />}
    </>
  );
};
